import type Alpine from "alpinejs";

const overflow: Alpine.DirectiveCallback = (
  el,
  { expression },
  { cleanup }
) => {
  const clsName = expression.length > 0 ? expression : "overflow";

  function update(elem: HTMLElement) {
    if (
      elem.scrollHeight > elem.clientHeight ||
      elem.scrollWidth > elem.clientWidth
    ) {
      elem.classList.add(clsName);
    } else {
      elem.classList.remove(clsName);
    }
  }

  const observer = new ResizeObserver((items) => {
    for (let i = 0; i < items.length; i++) {
      update(items[i].target as HTMLElement);
    }
  });

  observer.observe(el);

  update(el);
  for (let e of el.children) {
    update(e as HTMLElement);
    observer.observe(e);
  }

  cleanup(() => {
    observer.disconnect();
  });
};
export default overflow;
